import { Navigate, useLocation } from 'react-router'
import { useConsumerSession } from '@/consumer/hooks/use-consumer-session'
import { Loader2 } from 'lucide-react'

export function ConsumerProtectedRoute({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useConsumerSession()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[var(--color-surface)]">
        <Loader2 className="h-8 w-8 animate-spin text-[var(--color-accent)]" />
      </div>
    )
  }

  if (isError || !data) {
    const dest = `${location.pathname}${location.search}`
    // Don't preserve the root path - it's the default landing anyway.
    const suffix =
      dest && dest !== '/' ? `?next=${encodeURIComponent(dest)}` : ''
    return <Navigate to={`/login${suffix}`} replace />
  }

  // Enforce onboarding: a consumer who has not completed their name AND
  // accepted the Terms & Conditions cannot reach the rest of the app. The
  // onboarding page itself is exempt to avoid a redirect loop.
  if (data.needs_onboarding && location.pathname !== '/onboarding') {
    const dest = `${location.pathname}${location.search}`
    const suffix =
      dest && dest !== '/' ? `?next=${encodeURIComponent(dest)}` : ''
    return <Navigate to={`/onboarding${suffix}`} replace />
  }

  return <>{children}</>
}
